// @ts-nocheck
import React from "react";
import { format, parseISO } from "date-fns";

import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CheckIcon from "@material-ui/icons/Check";

import { isAtrasoLongo } from "../../../helpers/process.helper";
import { descricaoDocumento } from "./Documentacao";
import { Corpo, Selo, Titulo, Aviso, Blocos, Bloco, Progresso, Secao, Itens, Item, Recolhido, Ajuda, diasDaEtapa } from "./ui";

// "2026-08-28T00:00:00.000000Z" -> "28/08/2026" (sem converter fuso)
const dataCompleta = (data) => {
  const [ano, mes, dia] = String(data || "").slice(0, 10).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : null;
};

// Apostilamento (hague, docs_ok, unblocked). Sem status de apostila por
// documento na API: a barra conta os dias da previsão (decidido em 29/10/2026).
export default function Apostilamento({ process, isEssential }) {
  const requerente = process?.applicant?.name;
  const documentos = (process?.service_documents || []).filter((d) => d?.status !== "NOT_REQUIRED");
  const noCartorio = documentos.filter((d) => d?.hague);
  const prontos = documentos.filter((d) => !d?.hague);
  const dias = diasDaEtapa(process?.start_hague_prediction_date, process?.end_hague_prediction_date);
  const muitoAtrasado = dias?.atrasado && isAtrasoLongo(process?.end_hague_prediction_date);
  const previsao = process?.end_hague_prediction_date ? format(parseISO(process.end_hague_prediction_date), "dd/MM") : null;
  const destravado = process?.step?.name === "unblocked";
  const destravadoEm = dataCompleta(process?.unblocked_date);

  return (
    <Corpo>
      <Selo tipo="equipe" />

      {destravado && (
        <Aviso tipo="equipe">
          <b>{destravadoEm ? `Obstáculo resolvido em ${destravadoEm}` : "Obstáculo resolvido"}</b>
          <p>
            {isEssential
              ? "A reanálise aprovou a documentação. O pedido segue para o envio a Portugal."
              : "A reanálise aprovou a documentação. O pedido segue para o apostilamento e depois para o envio a Portugal."}
          </p>
        </Aviso>
      )}

      {dias?.atrasado ? (
        <>
          <Titulo>O apostilamento está levando mais tempo</Titulo>
          <p className="desc">Nossa equipe já está acompanhando este pedido. Assim que os documentos voltarem apostilados, você recebe um aviso aqui na Central.</p>
          <Aviso tipo="cliente">
            <p>
              <b>Passou do prazo previsto.</b>{" "}
              {muitoAtrasado ? "Pedimos desculpas pela demora; avisamos assim que terminar." : "Estamos trabalhando para concluir em até 2 dias úteis."}
            </p>
          </Aviso>
          <Blocos>
            <Bloco rotulo="Previsão inicial">
              <s>{previsao}</s>
            </Bloco>
            <Bloco rotulo="Nova previsão">{muitoAtrasado ? "A confirmar" : "Até 2 dias úteis"}</Bloco>
          </Blocos>
        </>
      ) : (
        <>
          <Titulo>Seus documentos estão sendo apostilados</Titulo>
          <p className="desc">
            Os documentos aprovados vão ao cartório para receber a apostila, exigida em Portugal. Os que já vieram apostilados seguem direto. Nada a fazer agora.
          </p>
          <Blocos>
            <Bloco rotulo="Quanto demora">Até 15 dias</Bloco>
            <Bloco rotulo="Previsão">{previsao ? `Até ${previsao}` : "A confirmar"}</Bloco>
          </Blocos>
          {dias && <Progresso rotulo={`Dia ${dias.atual} de ${dias.total} do apostilamento`} percentual={dias.percentual} />}
        </>
      )}

      {noCartorio.length > 0 && (
        <>
          <Secao>No cartório · {noCartorio.length}</Secao>
          <Itens>
            {noCartorio.map((doc) => (
              <Item
                key={`${doc?.reference_id}-${doc?.name}`}
                tipo="neutro"
                icone={<AccessTimeIcon />}
                titulo={doc?.name}
                descricao="Recebendo a apostila"
              />
            ))}
          </Itens>
        </>
      )}

      {prontos.length > 0 && (
        <Recolhido rotulo={`${prontos.length} documento${prontos.length === 1 ? "" : "s"} sem apostila pendente`}>
          <Itens>
            {prontos.map((doc) => (
              <Item
                key={`${doc?.reference_id}-${doc?.name}`}
                tipo="ok"
                icone={<CheckIcon />}
                titulo={doc?.name}
                descricao={/procura[çc][ãa]o/i.test(doc?.name || "") ? "Não precisa de apostila" : descricaoDocumento(doc, requerente) || "Já veio apostilado"}
              />
            ))}
          </Itens>
        </Recolhido>
      )}

      <Ajuda
        titulo="O que vem depois"
        passos={[
          { texto: "Documentos conferidos.", feito: true },
          "Apostila em todos os que precisam (agora).",
          "Despacho: montamos e enviamos o processo a Portugal.",
        ]}
      />
    </Corpo>
  );
}
